module.exports = __webpack_public_path__ + "static/media/3 12 Tulleord Brillter er feil.359b71c0.mp3";